<script>
import { mapActions, mapState } from 'vuex'

export default {
  props: [
    'id',
    'inverse'
  ],

  data () {
    return {
      is_launching: false,
    }
  },

  methods: {
    launchLab: function (event) {
      if(!this.reservation_transaction)
      {
        this.confirmLaunch()
        return
      }
      $('#confirmationModal' + this.id).modal('show')
    },
    confirmLaunch: function (event) {
      if(this.is_launching) {
        return
      }
      this.is_launching = true
      $('#confirmationModal'+this.id).modal('hide')
      window.location.href = this.launchUrl
    },
    connectToLab: function (event) {
      $('#confirmationModal'+this.id).modal('hide')
      window.location.href = Labstack.url + '/connect'
    }
  },

  computed: {
    ...mapState({
      current: state =>
        state.reservation.current,
      reservation_transaction: state =>
        state.reservation.reservation_transactions.find(
          t => t.id === state.reservation.current.id
        ),
      infrastructure_pod: state => {
        let transaction = state.reservation.reservation_transactions.find(
          t => t.id === state.reservation.current.id
        )
        return state.infrastructure.infrastructure_pods.find(
          p => p.id === transaction.relationships.infrastructure_pod.data.id
        )
      }
    }),

    launchUrl: function () {
      return Labstack.url + '/topologies/' + this.id + '/launch'
    },
    reservationUrl: function () {
      if(this.reservation_transaction == undefined) {
        return ''
      }

      let id = this.reservation_transaction.attributes.topology_blueprint_id

      return Labstack.url + '/topologies/' + id + '/launch'
    },
    isDisabled: function () {
      return this.is_launching ||
      this.current.is_loading ||
      (
        this.reservation_transaction &&
        // Pending status
        this.infrastructure_pod.attributes.pod_status == 2
      ) ||
      (
        this.reservation_transaction &&
        this.launchUrl == this.reservationUrl
      )
    }
  }
}
</script>

<template>
  <span>
    <a class="btn click-prevent" @click="launchLab" :class="{ 'disabled': isDisabled, 'btn-success': !inverse, 'btn-inverse btn-outline': inverse }">
      <i class="fa fa-magic"></i>&nbsp;&nbsp;
      Launch
    </a>
    <div class="modal fade" :id="'confirmationModal' + id" role="dialog">
      <div class="modal-dialog">
        <div class="modal-content text-left">
          <div class="modal-header">
            <button type="button" class="close" data-dismiss="modal" aria-label="Close"><span aria-hidden="true">&times;</span></button>
            <h4 class="modal-title">Launch Topology</h4>
          </div>
          <div class="modal-body">
            <p>
              You currently have a reservation. Are you sure you would like to launch this topology?
            </p>
          </div>
          <div class="modal-footer">
            <a class="btn btn-success" @click="confirmLaunch">
              <i class="fa fa-magic"></i>&nbsp;&nbsp;
              Launch
            </a>
            <a class="btn btn-default" @click="connectToLab">
              <i class="fa fa-desktop"></i>&nbsp;&nbsp;
              Connect
            </a>
          </div>
        </div>
      </div>
    </div>
  </span>
</template>
